// ViewGerenciarAnuncioVendaMobile.tsx

import { Col, Flex, Row, Typography } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button as MuiButton,
  Card,
  CardContent,
  CardHeader,
  Typography as MuiTypography,
  Box,
} from "@mui/material";
import SellIcon from "@mui/icons-material/Sell";
import {
  Visibility,
  TouchApp,
  Info,
  AccountBalanceWallet,
  SwapHoriz,
  CalendarToday,
  AttachMoney,
  Business,
} from "@mui/icons-material";
import { formatValorReal } from "../../../uteis/formatValorReal";
import { formatStatus } from "../../../uteis/statusFormatted";

const { Title } = Typography;

interface Props {
  nomeEmpreend: string;
  dataAnuncio?: string;
  dataInativacao?: string;
  visualizacoes?: number | null;
  qtdInteressados?: number | null;
  valorVenda?: number;
  valorCondominio?: number;
  situacao?: string;
  saldoDevedor?: number;
  aceitaTroca?: boolean;
  onClickEditar?: () => void;
  onClickInteressados?: () => void;
}

export default function ViewGerenciarAnuncioVendaMobile({
  nomeEmpreend,
  dataAnuncio,
  dataInativacao,
  visualizacoes,
  qtdInteressados,
  valorVenda,
  valorCondominio,
  situacao,
  saldoDevedor,
  aceitaTroca,
  onClickEditar,
  onClickInteressados,
}: Props) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginBottom={3} // menor para mobile
    >
      {/* Cabeçalho */}
      <Row
        gutter={[16, 16]}
        align="middle"
        style={{
          marginTop: 16,
          marginBottom: 16,
          width: "100%",
        }}
      >
        <Col flex="auto">
          <Flex
            align="center"
            justify="center"
            style={{ position: "relative" }}
          >
            {/* Botão voltar */}
            <a
              href={`/cadastroCotas`}
              style={{
                position: "absolute",
                left: 16, // ajustado para mobile
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <ArrowBackIcon color="primary" />
            </a>

            {/* Título e ícone centralizados */}
            <SellIcon
              style={{ marginRight: 8 }}
              color="primary"
              fontSize="large"
            />
            <Title style={{ margin: 0, whiteSpace: "nowrap" }} level={4}>
              Meu Anúncio
            </Title>
          </Flex>
        </Col>
      </Row>

      {/* Card principal */}
      <Card
        sx={{
          width: "100%",
          maxWidth: 360, // ajustado para mobile
          borderRadius: 2,
          boxShadow: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardHeader
          title={`Propriedade ${nomeEmpreend}`}
          subheader="Detalhes do seu anúncio ativo"
        />
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Visualizações */}
            <Box display="flex" alignItems="center" gap={1}>
              <Visibility sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body2">
                Visualizações: {visualizacoes}
              </MuiTypography>
            </Box>

            {/* Cliques de Contato */}
            <Box display="flex" alignItems="center" gap={1}>
              <TouchApp sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body2">
                Cliques de Contato: {qtdInteressados}
              </MuiTypography>
            </Box>
            {/* Situação */}
            <Box display="flex" alignItems="center" gap={1}>
              <Info sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body1">
                Situação: {formatStatus(situacao)}
              </MuiTypography>
            </Box>

            {/* Aceita troca */}

            <Box display="flex" alignItems="center" gap={2}>
              <SwapHoriz sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body1">
                Aceito Troca: {aceitaTroca ? "Sim" : "Não"}
              </MuiTypography>
            </Box>

            {/* Data início */}
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarToday sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body2">
                Início do anúncio: {dataAnuncio}
              </MuiTypography>
            </Box>

            {/* Data fim */}
            {dataInativacao && (
              <Box display="flex" alignItems="center" gap={1}>
                <CalendarToday sx={{ color: "text.secondary", fontSize: 20 }} />
                <MuiTypography variant="body2">
                  Fim do anúncio: {dataInativacao}
                </MuiTypography>
              </Box>
            )}

            {/* Valor de venda */}
            <Box display="flex" alignItems="center" gap={1}>
              <AttachMoney sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body2">
                Valor de venda: {formatValorReal(valorVenda)}
              </MuiTypography>
            </Box>

            {/* Valor condomínio */}
            <Box display="flex" alignItems="center" gap={1}>
              <Business sx={{ color: "text.secondary", fontSize: 20 }} />
              <MuiTypography variant="body1">
                Valor Condomínio: {formatValorReal(valorCondominio)}
              </MuiTypography>
            </Box>

            {/* Saldo devedor */}
            {situacao &&
              (situacao === "NAO_QUITADO" || situacao === "NA_PLANTA") && (
                <Box display="flex" alignItems="center" gap={2}>
                  <AccountBalanceWallet
                    sx={{ color: "text.secondary", fontSize: 20 }}
                  />
                  <MuiTypography variant="body1">
                    Saldo Devedor: {formatValorReal(saldoDevedor)}
                  </MuiTypography>
                </Box>
              )}
          </Box>

          {/* Botão de ação */}
          <Box mt={3} display="flex" flexDirection="column" gap={2}>
            <MuiButton
              onClick={onClickEditar}
              variant="contained"
              color="error"
              fullWidth
              size="large"
            >
              Editar
            </MuiButton>

            <MuiButton
              onClick={onClickInteressados}
              variant="contained"
              color="primary"
              fullWidth
              size="large"
            >
              Interessados
            </MuiButton>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
